import { action, createRequestTypes } from './base';

export const orderActionTypes = {
  GET_OPEN_ORDERS: createRequestTypes('GET_OPEN_ORDERS'),
  GET_CLOSED_ORDERS: createRequestTypes('GET_CLOSED_ORDERS'),
  GET_ORDER_BY_ID: createRequestTypes('GET_ORDER_BY_ID'),
  CREATE_BULK_ORDER: createRequestTypes('CREATE_BULK_ORDER'),
};

/**
 *
 */
class OrderActions {
    /**
     *
     * @param startDate
     * @param endDate
     * @return {{type: *}}
     */
    getOpenOrders = (startDate, endDate) => action(orderActionTypes.GET_OPEN_ORDERS.REQUEST, {
      startDate,
      endDate,
    })

    /**
     *
     * @param getOpenOrdersLoading
     * @return {{type: *}}
     */
    getOpenOrdersLoading = (getOpenOrdersLoading) => action(orderActionTypes.GET_OPEN_ORDERS.LOADING, {
      getOpenOrdersLoading,
    })

    /**
     *
     * @param openOrders
     * @return {{type: *}}
     */
    getOpenOrdersSuccess = (openOrders) => action(orderActionTypes.GET_OPEN_ORDERS.SUCCESS, {
      openOrders,
    })

    /**
     *
     * @param startDate
     * @param endDate
     * @return {{type: *}}
     */
    getClosedOrders = (startDate, endDate) => action(orderActionTypes.GET_CLOSED_ORDERS.REQUEST, {
      startDate,
      endDate,
    })

    /**
     *
     * @param getClosedOrdersLoading
     * @return {{type: *}}
     */
    getClosedOrdersLoading = (getClosedOrdersLoading) => action(orderActionTypes.GET_CLOSED_ORDERS.LOADING, {
      getClosedOrdersLoading,
    })

    /**
     * @param closedOrders
     * @param openOrders
     * @return {{type: *}}
     */
    getClosedOrdersSuccess = (closedOrders) => action(orderActionTypes.GET_CLOSED_ORDERS.SUCCESS, {
      closedOrders,
    })

    /**
     *
     * @param orderId
     * @return {{type: *}}
     */
    getOrderById = (orderId) => action(orderActionTypes.GET_ORDER_BY_ID.REQUEST, {
      orderId,
    })

    /**
     *
     * @param getOrderByIdLoading
     * @return {{type: *}}
     */
    getOrderByIdLoading = (getOrderByIdLoading) => action(orderActionTypes.GET_ORDER_BY_ID.LOADING, {
      getOrderByIdLoading,
    })

    /**
     *
     * @param selectedOrder
     * @return {{type: *}}
     */
    getOrderByIdSuccess = (selectedOrder) => action(orderActionTypes.GET_ORDER_BY_ID.SUCCESS, {
      selectedOrder,
    })

    /**
     *
     * @param payload
     * @return {{type: *}}
     */
    createBulkOrder = (payload) => action(orderActionTypes.CREATE_BULK_ORDER.REQUEST, {
      payload,
    })

    /**
     *
     * @param createBulkOrderLoading
     * @return {{type: *}}
     */
    createBulkOrderLoading = (createBulkOrderLoading) => action(orderActionTypes.CREATE_BULK_ORDER.LOADING, {
      createBulkOrderLoading,
    })

    /**
     *
     * @param showBulkOrderConfirmation
     * @return {{type: *}}
     */
    showBulkOrderConfirmation = (showBulkOrderConfirmation) => action(orderActionTypes.CREATE_BULK_ORDER.SUCCESS, {
      showBulkOrderConfirmation,
    })
}
export default new OrderActions();
